import { useCallback, useEffect, useState } from "react";
import { DealsAPI } from "../../api/deals";

interface Req {
  id: number;
  number: string;
  title: string;
  amount: number | string;
  clientName: string;
  requestedBy: string;
  requestedAt: string;
  reason: string | null;
}

const money = (n: number | string) => new Intl.NumberFormat("ru-RU").format(Number(n) || 0) + " ₸";

/** Кнопка со счётчиком и окно запросов на удаление сделок — для руководителя и администратора */
export default function DeleteRequestsButton({ onChanged }: { onChanged: () => void }) {
  const [list, setList] = useState<Req[]>([]);
  const [open, setOpen] = useState(false);
  const [busy, setBusy] = useState<number | null>(null);

  const load = useCallback(() => {
    DealsAPI.deleteRequests().then(setList).catch(() => setList([]));
  }, []);

  useEffect(() => {
    load();
    const t = setInterval(load, 60000);
    return () => clearInterval(t);
  }, [load]);

  const act = async (id: number, kind: "approve" | "reject") => {
    if (kind === "approve" && !window.confirm("Удалить сделку?")) return;
    setBusy(id);
    try {
      if (kind === "approve") await DealsAPI.approveDelete(id);
      else await DealsAPI.rejectDelete(id);
      load();
      onChanged();
    } catch (e: any) {
      alert(e?.response?.data?.message ?? "Не удалось выполнить действие");
    } finally {
      setBusy(null);
    }
  };

  if (list.length === 0 && !open) return null;

  return (
    <>
      <button
        onClick={() => setOpen(true)}
        style={{ padding: "6px 12px", borderRadius: 8, border: "1px solid rgba(239,68,68,0.45)", background: "rgba(239,68,68,0.1)", color: "#f87171", fontSize: 12, fontWeight: 700, cursor: "pointer", whiteSpace: "nowrap" }}
      >
        🗑 Запросы на удаление ({list.length})
      </button>

      {open && (
        <div style={{ position: "fixed", inset: 0, background: "rgba(0,0,0,0.7)", zIndex: 1200, display: "flex", alignItems: "center", justifyContent: "center", padding: 12 }}
          onClick={(e) => { if (e.target === e.currentTarget) setOpen(false); }}>
          <div style={{ background: "#0f1117", border: "1px solid #1f2937", borderRadius: 14, width: "min(720px, 96vw)", maxHeight: "86vh", overflow: "auto", padding: 18, color: "#e5e7eb" }}>
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 12 }}>
              <h3 style={{ margin: 0 }}>Запросы на удаление сделок</h3>
              <button onClick={() => setOpen(false)} style={{ background: "none", border: "none", color: "#9ca3af", fontSize: 20, cursor: "pointer" }}>✕</button>
            </div>
            {list.length === 0 && <div style={{ color: "#6b7280" }}>Запросов нет.</div>}
            {list.map((r) => (
              <div key={r.id} style={{ border: "1px solid #1f2937", borderRadius: 10, padding: "10px 12px", marginBottom: 8, background: "#11151f" }}>
                <div style={{ display: "flex", justifyContent: "space-between", gap: 10, flexWrap: "wrap" }}>
                  <b>{r.number} · {r.title}</b>
                  <span style={{ color: "#c084fc", fontWeight: 700 }}>{money(r.amount)}</span>
                </div>
                <div style={{ fontSize: 12, color: "#9ca3af", margin: "4px 0" }}>
                  Клиент: {r.clientName || "—"} · запросил: {r.requestedBy || "—"} · {new Date(r.requestedAt).toLocaleString("ru-RU")}
                </div>
                {r.reason && <div style={{ fontSize: 13, color: "#fca5a5", marginBottom: 6 }}>Причина: {r.reason}</div>}
                <div style={{ display: "flex", gap: 8 }}>
                  <button disabled={busy === r.id} onClick={() => act(r.id, "approve")}
                    style={{ padding: "6px 14px", borderRadius: 8, border: "none", background: "#ef4444", color: "#fff", fontWeight: 700, cursor: "pointer", fontSize: 12 }}>
                    Одобрить удаление
                  </button>
                  <button disabled={busy === r.id} onClick={() => act(r.id, "reject")}
                    style={{ padding: "6px 14px", borderRadius: 8, border: "1px solid #374151", background: "transparent", color: "#9ca3af", cursor: "pointer", fontSize: 12 }}>
                    Отклонить
                  </button>
                </div>
              </div>
            ))}
          </div>
        </div>
      )}
    </>
  );
}
